import React from 'react';
import PropTypes from 'prop-types';

// Renders a plain circle as AdvancedMarker DOM content, replacing the legacy
// `icon: { path: google.maps.SymbolPath.CIRCLE, ... }` marker icon.
const CircleMarker = ({ style: { fillColor, scale, strokeColor, strokeWeight = 0 } }) => {
  const diameter = scale * 2;
  return (
    <div
      style={{
        background: fillColor,
        border: `${strokeWeight}px solid ${strokeColor}`,
        borderRadius: '50%',
        boxSizing: 'border-box',
        height: diameter,
        width: diameter
      }}
    />
  );
};

CircleMarker.propTypes = {
  style: PropTypes.shape({
    fillColor: PropTypes.string,
    scale: PropTypes.number.isRequired,
    strokeColor: PropTypes.string,
    strokeWeight: PropTypes.number
  }).isRequired
};

export default CircleMarker;
